const CONFIG: any = {
  masterAddress: "0x456e2D23BEBB401FA56DCcC881fd915aC5f9d614",
  agentEmail: "stefano@korporatio.com",
  supportTeamEmail: "future@korporatio.com",
  timeZone: process.env.VUE_APP_TIME_ZONE,
  // backendHost: "api-xdai.korporatio.com",
  // backendPort: '4040',
  // backendProtocol: 'http',
  backendHost: "api-xdai.korporatio.com",
  backendPort: '',
  backendProtocol: 'https',
  endPoints: {
    ipfsAdd: '/api/files',
    ipfsGet: '/api/files',
    assets: '/api/assets',
    companyLink: '/api/assets/link',
    bitcoinHistory: '/api/bitcoin-history/$address',
    communicationsGet: '/api/communications',
    communicationsAdd: '/api/communications',
    chart: {
      data: '/api/chart',
      marketCup: '/api/chart/market-cup',
      dailyHigh: '/api/chart/daily-high',
      dailyVolume: '/api/chart/daily-volume'
    },
    mails: {
      notify: '/api/mails/notify',
      newmember: '/api/mails/newmember',
      approveMember: '/api/mails/approvemember',
      voting: '/api/mails/voting',
      resolveVoting: '/api/mails/resolvevoting',
      transfer: '/api/mails/transfer',
      agentTransfer: '/api/mails/agent/transfer',
      trade: '/api/mails/trade',
      agentTrade: '/api/mails/agent/trade',
      uploadFile: '/api/mails/uploadfile',
      uploadLegal: '/api/mails/uploadlegal'
    },
    stripe: {
      public: '/api/payments/stripe/public',
      purchase: '/api/payments/stripe/purchase'
    }
  },
  portis: {
    dappId: "3045f4e4-83a4-4048-bd7f-10427e16066a",
    network: "xdai",
    gasRelayHubAddress: '0xD216153c06E857cD7f72665E0aF1d7D82172F494'
    // network: "xdai",
  },
  featuresForBalance: [
    'CompanyDataFeature',
    'EscrowFeature',
    'FinancialStatementFeature',
    'LegalDocumentFeature',
    'MarketFeature',
    'MemberFeature',
    'OwnerFeature',
    'TokenFeature',
    'VotingFeature'
  ]
};


CONFIG.backendURL = CONFIG.backendProtocol +
  '://' +
  CONFIG.backendHost +
  (CONFIG.backendPort && CONFIG.backendPort !== '433' ? ':' + CONFIG.backendPort : '');;

const etherscanApi = 'WJKQAVUZZSM23V1F4YH6JDBZXTBY7T6WV9';

CONFIG.cryptocompare = {
  url: 'https://min-api.cryptocompare.com/data/price',
  params: {
    fsym: 'ETH',
    tsyms: 'USD'
  }
};

CONFIG.etherscan = {
  url: 'https://api.etherscan.io/api',
  balance: {
    params: {
      module: 'account',
      action: 'balance',
      address: null,
      tag: 'latest',
      apiKey: etherscanApi
    }
  },
  history: {
    params: {
      module: 'account',
      action: 'txlist',
      address: null,
      sort: 'asc',
      apiKey: etherscanApi,
      page: 1,
      offset: 100
    }
  },
  ethereumLastPrice: {
    params: {
      module: 'stats',
      action: 'ethprice',
      apiKey: etherscanApi
    }
  }
};

CONFIG.blockchain = {
  url: 'https://blockchain.info/',
  balance: {
    uri: 'balance',
    params: {
      active: null,
      cors: true
    }
  },
  history: {
    uri: 'rawaddr',
    params: {
      limit: 50,
      offset: 0
    }
  }
};

export default CONFIG;
